import {
  useEnvsToken,
  useGlobalWindowToken,
  useLocalStorageServiceToken,
  useResourcesToken,
} from '@/di/di.root-container.hooks';

import {PropsWithChildren, ReactElement} from 'react';

import router from 'next/router';

import {
  SecretCodeChecker,
  SecretCodeCheckerProps,
  createSecretCodePropsDisabled,
  createSecretCodePropsEnabled,
} from '@specials/secret-code';

async function shallowUrlReplace(targetUrl: URL): Promise<void> {
  await router.replace(targetUrl, undefined, {shallow: true});
}

export function AppSecretCodeChecker({children}: PropsWithChildren<unknown>): ReactElement {
  const globalWindow = useGlobalWindowToken();
  const localStorageService = useLocalStorageServiceToken();
  const envs = useEnvsToken();
  const {
    config: {secretCode},
  } = useResourcesToken();

  function buildSecretCodeParams(): SecretCodeCheckerProps {
    if (envs.APP_SECRET_CODE_ENABLED) {
      return createSecretCodePropsEnabled(() => ({
        config: secretCode,
        deps: {shallowUrlReplace, window: globalWindow, localStorage: localStorageService},
      }));
    } else {
      return createSecretCodePropsDisabled();
    }
  }

  return <SecretCodeChecker {...buildSecretCodeParams()}>{children}</SecretCodeChecker>;
}
